// https://app.growthbook.io/features/pen-5690_v1
export const HP_INNOVATIVE_SWING_FLAG_NAME = 'pen-5690_v1'
